import { useEffect, useRef } from "react";

const usePrevious = (value) => {
  const ref = useRef(value); //const ref = useRef(); // Inicializa o ref com o valor inicial
  useEffect(() => {
    ref.current = value; // Atualiza o valor do ref quando o valor do estado muda
  });
  return ref.current; // Retorna o valor do ref
};

export default usePrevious;
